export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_17.73342488.jpg";